import {
  Cloud,
  Target,
  Users,
  MessageCircle,
  Lightbulb,
  Handshake,
} from 'lucide-react';

export const DATA_EN = {
  cvPdf: "/pierre-touzeau_en.pdf",

  personal: {
    name: "Pierre Touzeau",
    role: "Cloud DevOps Engineer - Backend Engineer",
    location: "Bordeaux, France",
    email: "pierre.touzeau@outlook.fr",
    linkedin: "linkedin.com/in/pierre-touzeau",
    github: "github.com/pierretouzeaufr",
    availability: "Available",
    summary: "Passionate about backend development and new technologies, I combine DevOps expertise and programming to create innovative and scalable cloud solutions. Always on the lookout for tomorrow's tech to take on new technical challenges."
  },

  experiences: [
    {
      id: 1,
      company: "Capgemini",
      role: "Backend / DevOps Engineer",
      period: "2024 - Today",
      duration: "Ongoing",
      location: "Bordeaux",
      description: "For a major telecommunications client, working in the Backend team (L3) to create a provisioning and orchestration solution for a next-gen private cloud (eventually +30k VMs, volumes, flow management, load balancers, ultra-secure infrastructure, etc.). Developing the solution following client needs, process automation, and innovation periods.",
      achievements: [
        "Conception of a backend solution from scratch",
        "REST API Development",
        "Secure cloud-native architecture"
      ],
      skills: ["Kubernetes", "AI", "Docker", "Python", "GoLang", "Terraform (Provider)" , "Terraform (Client)", "GitLab CI", "Backend", "Cloud", "Agile"],
      current: true
    },
    {
      id: 2,
      company: "Capgemini",
      role: "Apprentice then DevOps Engineer",
      period: "2022 - 2024",
      duration: "2 years",
      location: "Bordeaux",
      description: "For a major client, working in the Services team (L2) to automate as many tasks as possible on a private cloud of 20,000 virtual machines.",
      skills: ["PowerShell", "Bash", "Cloud", "Docker", "GitLab CI"],
      current: false
    },
    {
      id: 3,
      company: "Assystem",
      role: "Apprentice then Industrial IT Technician",
      period: "2020 - 2022",
      duration: "2 years",
      location: "Paris",
      description: "In the design bureau for CNPE calculators, working on the design and maintenance of test benches.",
      skills: ["Bash", "Electronics", "Automation", "Networks", "Systems"],
      current: false
    },
    {
      id: 4,
      company: "EDF",
      role: "Apprentice Industrial IT & Electronics",
      period: "2018 - 2020",
      duration: "2 years",
      location: "Blayais Nuclear Power Plant",
      description: "Apprenticeship linked to my DUT in the automation department of a CNPE: maintenance of calculators and electronic cards.",
      skills: ["Electronics", "Automation"],
      current: false
    }
  ],

  skills: {
    languages: [
      { name: "Python", level: 60 },
      { name: "GoLang", level: 45 },
      { name: "Bash", level: 80 },
      { name: "PowerShell", level: 95 },
    ],
    infrastructure: [
      { name: "Kubernetes - Dev Part", level: 70 },
      { name: "Docker", level: 80 },
      { name: "Terraform", level: 90 },
      { name: "Ansible", level: 60 },
    ],
    cloud: [
      { name: "Google Cloud", level: 70 },
      { name: "GitLab CI", level: 90 },
      { name: "VMware", level: 60 },
      { name: "ELK Stack", level: 55 },
    ],
    soft: [
      { name: "Autonomy", icon: Target },
      { name: "Team Spirit", icon: Users },
      { name: "Communication", icon: MessageCircle },
      { name: "Proactivity", icon: Lightbulb },
      { name: "Problem Solving", icon: Handshake },
      { name: "Innovation", icon: Lightbulb },
    ]
  },

  certifications: [
    {
      name: "Associate Cloud Engineer",
      provider: "Google Cloud",
      date: "May 2024",
      icon: Cloud,
      verified: true
    }
  ],

  stats: {
    deployments: "10k+",
    terraformResources: "5k+",
    commits: "3k+",
    uptime: "99.9%"
  },

  pipeline: [
    { stage: "Apprentice DevOps", status: "passed", duration: "2 years" },
    { stage: "DevOps Engineer", status: "passed", duration: "3 years" },
    { stage: "Cloud DevOps Eng. / L3-Backend", status: "running", duration: "Ongoing" },
  ],

  projects: [
    {
      id: 1,
      name: "Cloud Manager",
      description: "API and backend software for private cloud provisioning and orchestration",
      tech: ["Kubernetes", "Docker", "Python", "MariaDB", "Redis", "RabbitMQ", "Go", "Terraform", "REST API"],
      stars: 0,
      forks: 0,
      status: "Ongoing",
      github: ""
    },
    {
      id: 2,
      name: "Homemade Provider",
      description: "Creation of a terraform provider adapted to the client's application, creation then maintenance of it to adapt to APIs",
      tech: ["Go", "Terraform"],
      stars: 0,
      forks: 0,
      status: "Ongoing",
      github: ""
    },
    {
      id: 3,
      name: "Dormant VM Management Scripts",
      description: "Script for detection, backup, deletion and communication of dormant VMs based on advanced metrics provided by the VMware stack",
      tech: ["VMware", "Vrops", "Powershell", "SMTP", "Gitlab-CI"],
      stars: 0,
      forks: 0,
      status: "Finished",
      github: ""
    },
    {
      id: 4,
      name: "General Private Cloud Reporting Scripts",
      description: "Daily generation from scripts of all client backend data, VMware stack, client data, etc.",
      tech: ["Python", "Powershell", "Gitlab-CI", "Linux", "Windows"],
      stars: 0,
      forks: 0,
      status: "Finished",
      github: ""
    }
  ]
};
